import { Component, ElementRef, EventEmitter, forwardRef, Input, OnChanges, OnInit, Output, Self, SimpleChanges, ViewChild } from '@angular/core';
import { ControlValueAccessor, UntypedFormControl, NgControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatAutocomplete } from '@angular/material/autocomplete';
//import { input } from 'aws-amplify';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { RelatiesService } from '../../dataservices/relaties.service';
import { ActiveRelatie } from '../../model/relatie';

@Component({
  selector: 'app-inputrelatie',
  templateUrl: './inputrelatie.component.html',
  styleUrls: ['./inputrelatie.component.less'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => InputrelatieComponent),
    multi: true
}]
})
export class InputrelatieComponent implements OnInit,  ControlValueAccessor {


  @Input() label : string = "Bedrijf";
  @Input() showLabel : string = "true";

  BedrijfNummer : number;
  myControl = new UntypedFormControl();
  private relaties :Array<ActiveRelatie>;
  filteredRelaties: Observable<ActiveRelatie[]>;

  @ViewChild(MatAutocomplete)
  private autoComplete!: MatAutocomplete;
  private input : any;

  constructor(private relatiesService : RelatiesService,
    private elRef:ElementRef) {
              }

  ngOnInit(): void {
    this.relatiesService.getActiveRelatieList().subscribe(data => {
      this.relaties = data;
      this.filteredRelaties = this.myControl.valueChanges
      .pipe(
        startWith(''),
        map(value => typeof value === 'string' ? value : (value != null ? value.BedrijfsNaam : '') ),
        map(name => name ? this._filter(name) : this.relaties.slice())
      );
      this.initBedrijf();
    })

  }

  showTheLabel() : boolean {
    return this.showLabel == "true"
  }

  ngAfterViewInit() {
    this.input = this.elRef.nativeElement.querySelector('.mat-mdc-autocomplete-trigger');
  }

  // to be replaced with actual functions
  onChange = (_) => { };
  onTouched = () => { };


  reset() {
    //todo: This is a hacky way to clear the input. Very nasty. Need to find a better way.
    this.autoComplete.autoSelectActiveOption = null;
    this.input.value = "";
    // changes.prop contains the old and the new value...
  }

  private _filter(name: string): ActiveRelatie[] {
    const filterValue = name.toLowerCase();
    return this.relaties.filter(option =>  /*(option.BedrijfsNaam).toLowerCase().startsWith(filterValue) ||*/
          option.Afkorting.toLowerCase().startsWith(filterValue));
  }


  initBedrijf() {
    if (this.BedrijfNummer &&  this.relaties) {
      const currentrelatie = this.relaties.find(data => data.BedrijfNummer == this.BedrijfNummer);
      //console.log(currentrelatie);
      if (currentrelatie) this.myControl.setValue(currentrelatie);
    }
  }


  displayBedrijf(relatie: ActiveRelatie ): string {
    if (relatie == null) return '';
    return relatie.Afkorting;
  }



  select(event: any) {
    this.onChange(event.option.value.BedrijfNummer);
  }

  writeValue(value: any): void {
    this.BedrijfNummer = value;
    this.initBedrijf();
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    if (isDisabled) this.myControl.disable(); else  this.myControl.enable();
  }

}
